import React from 'react';

import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';
import { HoldingDetail } from '../../../../../../generated/model/models';
import DetailsDataTableWithHistory from '../../shared/DetailsDataTableWithHistory';

export interface Props {
  data?: HoldingDetail;
}

const columns: MainColumns[] = [
  {
    field: 'ownedCompany',
    minWidth: 200,
    flex: 1,
    cellRenderer: CellRenderer.ValueOrUnknown,
    cellClass: 'multipleLineCell',
    autoHeight: true,
  },
  { field: 'ownershipType', minWidth: 200, flex: 1 },
  { field: 'sharesText', minWidth: 200, flex: 1 },
  { field: 'votingSharesText', minWidth: 200, flex: 1 },
  { field: 'officialValidFrom', minWidth: 150, flex: 1 },
  { field: 'officialValidTo', minWidth: 150, flex: 1 },
];

const OwnershipHoldings: React.FC<Props> = ({ data }) => {
  return (
    <DetailsDataTableWithHistory
      title={'holdings'}
      translationsScope={'companies:companyOwnership'}
      data={data}
      columns={columns}
      defaultHistoryToggleValue={true}
    />
  );
};

export default OwnershipHoldings;
